import { useCallback } from 'react'

import { useLocation, useNavigate, useSearchParams } from 'react-router'

import {
  type BidCsvImportNotice,
  resolveBidCsvImportDestination,
  toBidCsvImportReturnState,
} from '~/models/bidCsvImportReturn'
import { CSV_IMPORT_RETURN_TO_PARAM } from '~/models/csvImportReturn'

/**
 * 入札 CSV の取込画面が使う。 確定が成功したら、 すぐ入札画面へ移り、 取込結果 (件数・
 * 着地の受渡日・エリア・売買) を location state で渡す。 移った先が成功のトースト
 * (除いた行があればエラーバナー) を出す (AC-SPOT-024 / AC-BCI-038)。
 *
 * 行き先は取込画面の URL の returnTo (検証済み) がその種別の入札画面を指す時はそれ
 * (`?workflowId=` 等を保つため)、 それ以外は入札画面の path。
 */
export function useBidCsvImportReturn(
  bidPagePath: string,
): (notice: BidCsvImportNotice) => void {
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const rawReturnTo = searchParams.get(CSV_IMPORT_RETURN_TO_PARAM)

  return useCallback(
    (notice) => {
      const destination = resolveBidCsvImportDestination(
        rawReturnTo,
        pathname,
        bidPagePath,
      )
      void navigate(destination, { state: toBidCsvImportReturnState(notice) })
    },
    [bidPagePath, navigate, pathname, rawReturnTo],
  )
}
